export default {
	field_cannot_be_empty: "O campo não pode estar vazio"
}
